import { useContext } from 'react';
import {
  IUseItemFunctionMenuItemsTypeInput,
  useItemFunctionMenuItemsType,
} from '../../../../../../Utils/ObjektVyUtils';
import { BusinessDataFormContext } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import BokforderContext from '../Components/BokforderContext/BokforderContext';
import { BokforderType__Associations_Rader } from '../Queries/_QueryTypes/BokforderType';

const useRowFunctionMenuItems: useItemFunctionMenuItemsType = (
  input: IUseItemFunctionMenuItemsTypeInput,
  customData: { disabled?: boolean }
) => {
  const bokforderContext = useContext(BokforderContext);
  const formContext = useContext(BusinessDataFormContext);

  const rowID = input.item?.id;

  const isRowFromVerifikation = input.item?.REF_LOPNR != null;

  const numberOfEditableRows: number =
    formContext?.parentFormContext?.formState.currentValues?._Associations?.Rader?.filter(
      (row: BokforderType__Associations_Rader) =>
        row.REF_LOPNR == null && row.ATTESTERAD_DATUM == null
    )?.length ?? 0;

  let disabledReason = '';

  if (!bokforderContext.isEditMode && customData?.disabled === true) {
    disabledReason = 'Du är inte i redigeringsläge';
  } else if (isRowFromVerifikation) {
    disabledReason = 'Du kan inte ta bort den rad som ska ombokföras/vändas';
  } else if (numberOfEditableRows <= 1) {
    disabledReason = 'Du kan inte ta bort den sista redigerbara raden';
  } else if (!rowID) {
    disabledReason = 'Raden har ett felaktivt id';
  } else if (input.item?.ATTESTERAD_DATUM != null) {
    disabledReason = 'Raden är redan attesterad';
  }

  return [
    {
      id: 'deleteRows',
      caption: 'Ta bort rad',
      iconType: 'delete',
      disabled: disabledReason !== '',
      disabledReason: disabledReason,
      onClick: () => {
        if (rowID && numberOfEditableRows > 1) {
          bokforderContext.deleteBokforderRad(rowID);
        }
      },
    },
  ];
};

export default useRowFunctionMenuItems;
